import React from "react";

const Contact = ():JSX.Element => {
    return (
        <>Coming soon :)</>
    )
}

export default React.memo(Contact)